module.exports = __webpack_public_path__ + "img/banner01.43c57eec.png";